import { useState, useEffect } from 'react'
import FormGroup from '@mui/material/FormGroup';
import ActionButton from './actionButton';
import { TextField } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import Container from '@mui/material/Container';
import VolunteerList from './VolunteerList';
import useListVolunteers from '../services/volunteerService';
import Alert from '@mui/material/Alert';
import { Backdrop, Box } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';


const useStyles = makeStyles((theme) => ({
    backdrop: {
      zIndex: theme.zIndex.drawer + 1,
      color: '#fff',
    },
  }));


const Volunteers = () => {
    const classes = useStyles();
    const [username, setUsername] = useState('')
    const [email, setEmail] = useState('')
    const [showAlert, setShowAlert] = useState(false)
    const { volunteersData, isLoadingVolunteers, volunteersServerError, refresh, addVolunteer, toggleVolunteer, makeAdmin } = useListVolunteers();
    

    const add = (e) => {
        e.preventDefault()

        if (!username) {
            alert("No username entered")
        }
        else if (!email) {
            alert("No email address entered")
        }
        else {
            console.log(username)
            setShowAlert(true)
            addVolunteer(username, email)
        }
    }

    const switchVolunteer = async (username, enabled) => {
        toggleVolunteer(username, enabled)
    }


    useEffect(() => {
        setShowAlert(true)
    }, [isLoadingVolunteers, setShowAlert])


    return (
        <Box sx={{ mt: 2}}>
            <FormGroup >
                <Container id="VolunteerBox" disableGutters>
                    <TextField required id="addVolunteername" 
                        label="Toe te voegen username" 
                        value={username} 
                        onChange={(e) => setUsername(e.target.value)} 
                        sx={{ backgroundColor: 'common.white', mr: 1}}
                        />
                    <TextField required id="addVolunteeremail" 
                        label="Emailadres" 
                        value={email} 
                        onChange={(e) => setEmail(e.target.value)} 
                        sx={{ backgroundColor: 'common.white', width: '300px', mr: 1}}
                        />
                    <ActionButton id="AddButton" 
                        color="buttonOrange" 
                        onClick={ add } 
                        disabled={(username.length === 0 || email.length === 0)} 
                        sx={{ mt: '4px'}} >
                    Toevoegen
                    </ActionButton>
                </Container>
            </FormGroup>

            {(volunteersData) &&
                <VolunteerList volunteers={volunteersData} changeVolunteer={switchVolunteer} makeAdmin={makeAdmin} />}
            {volunteersServerError && showAlert && <Alert onClose={() => {setShowAlert(false)}} severity="error">{volunteersServerError}</Alert>}

            <Backdrop 
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={isLoadingVolunteers}
            >
            <CircularProgress color="inherit" />
            </Backdrop>
        </Box>
    )
}

export default Volunteers